import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useRouteMatch } from 'react-router'
import { getUserSubPackages } from '../../store/user/selectors'
import system_configuration from '../../assets/images/cheque.svg'
import { Col, Row } from 'react-bootstrap'
import TileButtonComponent from '../../components/common/tileButton/TileButtonComponent'
import { SubPackageModal } from '../../models/package/subPackageModal'
import ManageChequePayments from './manageChequePayments/ManageChequePayments'
import ChequePrint from './chequePrint/ChequePrint'

const ChequePayments = () => {
  const { path } = useRouteMatch()
  const subPackageList = useSelector(getUserSubPackages('cheque-payment'))
  const renderSubPackages = () => {
    return subPackageList.map((subPackage: SubPackageModal, index: number) => {
      return (
        <Col key={`sub-package-${index}`} sm={12} lg={6} className="mt-4">
          <TileButtonComponent
            name={subPackage.description}
            routeURL={subPackage.name}
          />
        </Col>
      )
    })
  }

  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Row className="title-layout">
          <Col className="d-flex justify-content-start">
            <img src={system_configuration} alt="" />
            <span className="m-2">Cheque Payments</span>
          </Col>
        </Row>
        <Row className="page-tiles-layout">{renderSubPackages()}</Row>
      </Route>
      <Route
        path={`${path}/manage-cheque-details`}
        component={ManageChequePayments}
      />
      <Route path={`${path}/cheque-print`} component={ChequePrint} />
    </Switch>
  )
}

export default ChequePayments
